import styled from 'styled-components'

// Styled Components
import { S_StatusBanner } from '../../../_components/StatusBanner'
import { cssBreakpoints } from '../../../_constants/styles'
import { S_FilesManager } from '../../../_components/FilesManager'

export const S_InvoicesOverview = styled.div`
  ${S_FilesManager} {
    margin-top: 15px;
  }

  .page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .invoice-table-row:hover {
    cursor: pointer;
  }
  .actions {
    button {
      display: block;
      margin-bottom: 20px;
    }
  }
  .business-selection {
    display: flex;
    justify-content: space-between;
    margin-bottom: 48px;
    .right {
      display: flex;
      align-items: flex-end;
      padding-top: 20px;
      flex-wrap: wrap;
      ${S_StatusBanner} {
        margin-right: 5px;
      }
    }
  }
  .face-value {
    display: flex;
    margin-left: 16px;
    font-size: 20px;
    .value-amt {
      margin-left: 8px;
    }
  }
  .err-banner {
    background-color: #efefef;
    border-color: #999;
    border-radius: 5px;
    border-style: solid;
    border-width: 1px;
    display: flex;
    margin-left: auto;
    margin-right: 16px;
    max-height: 60px;
    max-width: 85%;
    padding-bottom: 0;
    padding-top: 0;
    white-space: nowrap;
  }
  .table-errs {
    white-space: nowrap;
    margin-left: 16px;
    min-width: fit-content;
    max-height: 35px;
    min-height: 35px;
  }
  .table-errs:first-child {
    margin-left: 0;
  }
  .btn-wrapper {
    margin-left: auto;
  }
  .left {
    display: flex;
    justify-content: space-between;
  }

  .create-layout {
    display: flex;
  }
  .save-client-btn {
    margin-left: 16px;
    max-height: 39px;
    margin-top: 20px;
  }
  ${S_StatusBanner} {
    .message-inner {
      white-space: normal;
    }
  }
  .add-icon {
    margin-right: 4px;
  }
  .table-controls-btn {
    margin-right: 16px;
  }
  .table-controls-btn:last-child {
    margin-right: 0;
  }
  .funded-checkbox {
    background-color: blue;
  }
`

export const S_InvoicesOverview_TableControls = styled.div`
  margin-top: 15px;
  text-align: right;

  @media screen and (max-width: ${cssBreakpoints.mobileLg}) {
    text-align: left;
  }
`

export const S_LinkCell = styled.div`
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  cursor: pointer;
  :hover {
    text-decoration: underline;
  }
  a {
    display: inline-block;
    width: 100%;
    :hover {
      text-decoration: underline;
    }
  }
`
